import { Box, Flex, Text, IconButton, Badge } from "@chakra-ui/react";
import { FaEdit, FaEye, FaEyeSlash } from "react-icons/fa";
import { memo, useState } from "react";
import PropertyEntriesModal from "./PropertyEntriesModal";

const problemCount = (property) => property.entries.filter((entry) => entry.isProblem && entry.isActive).length;

const PropertyList = ({ properties, onEdit, onDeactivate }) => {
    const [openEntriesId, setOpenEntriesId] = useState(null);
    const activeProperty = properties.find((property) => property.id === openEntriesId) || null;

    const openEntries = (propertyId, event) => {
        if (event.target.closest(".edit-icon, .deactivate-icon, .add-icon")) return;
        setOpenEntriesId(propertyId);
    };

    return (
        <>
            {properties.length > 0 ? (
                properties.map((property) => {
                    const count = problemCount(property);
                    return (
                        <Box
                            key={property.id}
                            bg="surface.50"
                            borderRadius="lg"
                            border="1px solid"
                            borderColor="gray.100"
                            p={3}
                            mb={3}
                            ml={{ base: 0, md: 4 }}
                            cursor="pointer"
                            onClick={(e) => openEntries(property.id, e)}
                        >
                            <Flex justify="space-between" align="center" gap={3}>
                                <Box minW={0}>
                                    <Text fontWeight={count > 0 ? "bold" : "600"} color={count > 0 ? "red.600" : "brand.700"}>
                                        {property.name}
                                        {count > 0 && (
                                            <Badge as="span" ml={2} borderRadius="full" bg="red.500" color="white" px={2} fontSize="xs" verticalAlign="middle">
                                                {count}
                                            </Badge>
                                        )}
                                    </Text>
                                </Box>
                                <Flex flexShrink={0} align="center" gap={2}>
                                    <IconButton
                                        icon={<FaEdit />}
                                        size="sm"
                                        className="edit-icon"
                                        aria-label="Edit property"
                                        onClick={() => onEdit("property", property)}
                                    />
                                    <IconButton
                                        icon={property.isActive ? <FaEyeSlash /> : <FaEye />}
                                        size="sm"
                                        className="deactivate-icon"
                                        aria-label={property.isActive ? "Deactivate property" : "Activate property"}
                                        onClick={() => onDeactivate("property", property)}
                                    />
                                </Flex>
                            </Flex>
                        </Box>
                    );
                })
            ) : (
                <Text color="gray.500" fontSize="sm" ml={{ base: 0, md: 4 }}>Nema svojstava u ovoj kategoriji.</Text>
            )}

            <PropertyEntriesModal
                property={activeProperty}
                isOpen={!!activeProperty}
                onClose={() => setOpenEntriesId(null)}
                onEdit={onEdit}
                onDeactivate={onDeactivate}
            />
        </>
    );
};

export default memo(PropertyList);
